import { FC } from 'react';
import { cx } from '@emotion/css';

import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';
import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';

import { DynamicLinkWrapper, LinkWrapperProps } from '../../dynamic-link-wrapper';

interface PlaceholderCardProps extends LinkWrapperProps {
  header?: string;
  description?: string;
  imageSrc?: string;
  isVisible?: boolean;
}

export const PlaceholderCard: FC<PlaceholderCardProps> = ({ isVisible, className, routePath, header, description, imageSrc, children }) => (
  <DynamicLinkWrapper routePath={isVisible ? routePath : ''} allowReferrer={true}>
    <div
      className={cx(
        'flex h-[328px] tablet:h-[496px] flex-col items-center justify-center rounded-md bg-secondary-lighter p-8 desktop:px-12',
        className
      )}
    >
      {isVisible && children}
      {imageSrc && (
        <div className="relative h-[11.75rem] w-full">
          <PhoenixImage
            src={imageSrc}
            layout="fill"
            objectFit="contain"
            sizes={`(max-width: ${containerQueries.tablet}) 90vw, (max-width: ${containerQueries.desktop}) 50vw, 30vw`}
            staticTags={['imagesDashboard']}
          />
        </div>
      )}
      {(header || description) && (
        <div>
          {header && <h2 className="!font-['STIHL-Contraface-Text'] stihl-text-h2-desktop">{header}</h2>}
          {description && <p className="mt-5 stihl-text-body-default-reg">{description}</p>}
        </div>
      )}
    </div>
  </DynamicLinkWrapper>
);
